import * as React from 'react';

/**
 * Returns the initial value when the component is mounted.
 */
export function useInitialValue<T>(value: T): T {
    const [initialValue] = React.useState<T>(value);
    return initialValue;
}
